// extracted by mini-css-extract-plugin
export default {"phonePortraitWidth":"strip-unit(667px)","phoneLandscapeWidth":"strip-unit(896px)","tabletPortraitWidth":"strip-unit(992px)","tabletLandscapeWidth":"strip-unit(1366px)"};